import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
require('./styles.scss')

export default function DropdownContainer(props) {

  return (
    <div
      className={classNames(
        props.className || 'dropdown-container',
        'dropdownContainer'
      )}
    >
      {props.children}
    </div>
  )

}

DropdownContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
